import React from 'react';
import { CheckIcon } from 'lucide-react';
import { CtaButton } from './CtaButton';
import { Pill } from './Pill';
import { heroBadges, heroImage, stats } from '../data/copy';
export function Hero() {
  return <header className="w-full bg-ink" data-id="element-89" data-mp="9k0gndfbepsa">
      <div className="mx-auto max-w-4xl px-6 pb-10 pt-8 text-center sm:pt-10" data-id="element-90" data-mp="9l33na9io82x">
        <Pill tone="gold" data-id="element-91" data-mp="4n1ov1j4iux9">Para entrenadores de atletismo</Pill>

        

        <h1 className="mx-auto mt-4 max-w-3xl font-display text-[2.3rem] font-bold leading-[1.05] text-ivory sm:text-5xl lg:text-[3.5rem]" style={{
        fontSize: "28px"
      }} data-id="element-92" data-mp="129qudld1bpnv">
          Planifica tu entrenamiento en{' '}
          <span className="text-gold" data-id="element-93" data-mp="sa9n4zi4x3ps">5 minutos</span>, no en 5 horas
        </h1>

        {/* El mockup va inmediatamente debajo de la promesa (el titular). */}
        <div className="relative mt-7" data-id="element-94" data-mp="3d1a83izra9cr">
          <div className="absolute inset-x-0 bottom-8 top-10 rounded-4xl bg-coal" aria-hidden="true" data-id="element-95" data-mp="3d2bkprwf73wl" />
          <img src={heroImage} alt="El Megapack Atletismo 360 completo: estuche, 6 volúmenes técnicos y 5 bonos impresos." className="relative mx-auto w-full max-w-sm sm:max-w-xl lg:max-w-2xl" width={1240} height={1240} sizes="(max-width: 640px) 384px, (max-width: 1024px) 576px, 672px" decoding="async" loading="eager" {...{
          fetchpriority: 'high'
        }} data-id="element-96" data-mp="381nwfdzkt162" />
        </div>

        <p className="mx-auto mt-4 max-w-readable font-sans text-base leading-relaxed text-stone" style={{
        fontSize: "14px"
      }} data-id="element-97" data-mp="3e8egb8bghk3y">
          El sistema completo para entrenadores de atletismo en español: 6
          volúmenes técnicos, +70 sesiones listas para usar y 5 bonos
          exclusivos.
        </p>

        <div className="mt-7" data-id="element-98" data-mp="2ql6a8o67e70v">
          <CtaButton href="#oferta" size="large" className="w-full sm:w-auto" data-id="element-99" data-mp="2qhqvjmgfyzzz">
            Acceso completo ahora
          </CtaButton>
        </div>

        <ul className="mt-6 flex flex-wrap justify-center gap-x-5 gap-y-2" data-id="element-100" data-mp="2hix2g62bkrr6">
          {heroBadges.map(badge => <li key={badge} className="flex items-center gap-1.5 font-sans text-[11px] text-stone sm:text-xs" data-id="element-101" data-mp="2ll0ht5s40ghq">
              <CheckIcon className="h-3.5 w-3.5 text-gold" strokeWidth={2.6} aria-hidden="true" data-id="element-102" data-mp="s2tenov66frb" />
              {badge}
            </li>)}
        </ul>
      </div>

      <dl className="border-y border-line bg-coal" data-id="element-103" data-mp="ibyqgeyd5638">
        <div className="mx-auto grid max-w-6xl grid-cols-3 divide-x divide-line px-6" data-id="element-104" data-mp="icrn2n3lyf7n">
          {stats.map(stat => <div key={stat.label} className="px-3 py-7 text-center" data-id="element-105" data-mp="deyj80ps1xaj">
              <dt className="sr-only" data-id="element-106" data-mp="1azumdhg3ytyy">{stat.label}</dt>
              <dd data-id="element-107" data-mp="161t3awiomunh">
                <span className="block font-display text-4xl font-bold leading-none text-gold sm:text-5xl" data-id="element-108" data-mp="161ayhbhyf83y">
                  {stat.value}
                </span>
                <span className="mt-2 block font-sans text-[10px] font-semibold uppercase tracking-[0.18em] text-stone sm:text-xs" data-id="element-109" data-mp="114suidug7dso">
                  {stat.label}
                </span>
              </dd>
            </div>)}
        </div>
      </dl>
    </header>;
}